var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItsmarcosjreyesHeaderSmallWamhTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "630px",
    height: "630px",
    viewBox: "0 0 630 630",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "itsmarcosjreyes-header-small-wamh-top") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "itsmarcosjreyes-header-small-wamh-top",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FF5B00",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 45,
    y: 45,
    width: 540,
    height: 540,
    rx: 270
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(315.000000, 314.729201) rotate(-45.000000) translate(-315.000000, -314.729201) translate(65.000000, 183.000000)",
    fill: "#FFFFFF",
    stroke: "#FF5B00",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.908646,47.3083197 L489.370628,47.3083197 C496.456876,75.1767265 500,103.045133 500,130.91354 C500,158.781947 496.456876,186.650353 489.370628,214.51876 L411.908646,214.51876 C418.994894,187.276288 422.538018,159.617418 422.538018,131.542151 C422.538018,103.466883 418.994894,75.3889398 411.908646,47.3083197 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.701468,0 L435.587366,0 C443.727599,43.9097336 447.797716,87.8194671 447.797716,131.729201 C447.797716,175.638934 443.727599,219.548668 435.587366,263.458401 L390.701468,263.458401 C398.841702,220.534896 402.911819,176.955311 402.911819,132.719646 C402.911819,88.4839809 398.841702,44.244099 390.701468,0 Z",
    id: "Rectangle",
    transform: "translate(419.249592, 131.729201) scale(-1, 1) translate(-419.249592, -131.729201) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.593801,27.7324633 L415.548645,27.7324633 C427.803871,62.3980424 433.931485,97.0636215 433.931485,131.729201 C433.931485,166.39478 427.803871,201.060359 415.548645,235.725938 L72.593801,235.725938 C84.8490271,201.83896 90.9766402,167.434024 90.9766402,132.511131 C90.9766402,97.5882377 84.8490271,62.6620151 72.593801,27.7324633 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.936378,0 L447.822276,0 C455.96251,43.9097336 460.032626,87.8194671 460.032626,131.729201 C460.032626,175.638934 455.96251,219.548668 447.822276,263.458401 L402.936378,263.458401 C411.076612,220.534896 415.146729,176.955311 415.146729,132.719646 C415.146729,88.4839809 411.076612,44.244099 402.936378,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7553018,0 L101.05347,0 C110.356595,43.9097336 115.008157,87.8194671 115.008157,131.729201 C115.008157,175.638934 110.356595,219.548668 101.05347,263.458401 L49.7553018,263.458401 C59.058426,220.534896 63.709988,176.955311 63.709988,132.719646 C63.709988,88.4839809 59.058426,44.244099 49.7553018,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 50.1631321,
    cy: 131.729201,
    rx: 19.1680261,
    ry: 131.729201
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6035889,47.3083197 L48.4905231,47.3083197 C53.6838992,75.1767265 56.2805873,103.045133 56.2805873,130.91354 C56.2805873,158.781947 53.6838992,186.650353 48.4905231,214.51876 L10.6035889,214.51876 C15.796965,187.276288 18.3936531,159.617418 18.3936531,131.542151 C18.3936531,103.466883 15.796965,75.3889398 10.6035889,47.3083197 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.0114192,
    cy: 130.91354,
    rx: 11.0114192,
    ry: 83.6052202
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.367047,27.7324633 L339.171134,27.7324633 C348.511096,62.3980424 353.181077,97.0636215 353.181077,131.729201 C353.181077,166.39478 348.511096,201.060359 339.171134,235.725938 L175.367047,235.725938 C184.707009,201.83896 189.37699,167.434024 189.37699,132.511131 C189.37699,97.5882377 184.707009,62.6620151 175.367047,27.7324633 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.61624,27.7325657 C401.127654,62.482029 405.383361,97.2314922 405.383361,131.980956 C405.383361,147.258702 404.56075,162.536449 402.91553,177.814196 L360.817291,177.813623 C362.403594,162.894108 363.196745,147.877827 363.196745,132.764778 C363.196745,98.1757996 359.042162,63.5835633 350.732996,28.988069 L350.743362,27.7324633 L392.61624,27.7325657 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.803453,222.675367 L129.690049,222.675367 C133.529462,201.172679 135.918313,179.421647 136.856602,157.422269 L225.93801,157.422511 C224.97815,179.173463 222.599964,200.924415 218.803453,222.675367 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.7610594,
    y1: 32.2185971,
    x2: 108.159006,
    y2: 32.2185971,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.024919,
    y1: 72.1859706,
    x2: 112.236092,
    y2: 72.1859706,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.6574225,
    y1: 112.153344,
    x2: 114.681892,
    y2: 112.153344,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.6574225,
    y1: 150.489396,
    x2: 114.681892,
    y2: 150.489396,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.024919,
    y1: 193.719413,
    x2: 112.236092,
    y2: 193.719413,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.9453987,
    y1: 232.871126,
    x2: 107.343345,
    y2: 232.871126,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.971085,
    y1: 32.2185971,
    x2: 453.182259,
    y2: 32.2185971,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.049389,
    y1: 72.1859706,
    x2: 457.260562,
    y2: 72.1859706,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.496371,
    y1: 112.153344,
    x2: 459.707544,
    y2: 112.153344,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.496371,
    y1: 150.489396,
    x2: 459.707544,
    y2: 150.489396,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.049389,
    y1: 193.719413,
    x2: 457.260562,
    y2: 193.719413,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.339764,
    y1: 232.871126,
    x2: 451.550937,
    y2: 232.871126,
    id: "Line",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItsmarcosjreyesHeaderSmallWamhTop);
export default __webpack_public_path__ + "static/media/itsmarcosjreyes-header-small-wamh-top.de7cca75b82768e22e9fa010469a6ea3.svg";
export { ForwardRef as ReactComponent };